import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  background-color: red;
  align-items: center;
  margin: 10px;
  background-color: #131921;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  align-items: space-between;
  justify-content: space-between;
`
export const Input = styled.input`
  width: 200px;
`

export const Textarea = styled.textarea`
  width: 200px;
`

export const Label = styled.label`
  color: white;
  display: flex;
  flex-direction: column;
  padding: 5px;
`

export const Button = styled.button`
  // background-color: rgb(243, 168, 71);
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px 0px 5px 0px;
`
